import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styled from 'styled-components';
import { Typography } from '.';
import Chevron from '../assets/images/chevron-black.svg';
import { colors } from '../utils';
import { getAll as jobGetAllAction } from '../lib/redux/actions/job';
import { changeMetricsDuration as changeMetricsDurationAction } from '../lib/redux/actions/me';

const DateFilterWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  justify-content: right;
  align-items: flex-end;
  position: relative;
`;

const DurationSelected = styled(Typography)`
  display: flex;
  cursor: pointer;
  padding: 3px;

  &:hover {
    color: ${colors.g05};
  }
`;

const ChevronIcon = styled.img`
  height: 20px;
  width: 20px;
  transform: rotate(${({ isMenuOpen }) => (isMenuOpen ? 180 : 0)}deg);
`;

const DurationList = styled.div`
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  right: 0px;
  top: 25px;
  padding: 8px 0px 8px 0px;
`;

const DurationItem = styled(Typography)`
  padding: 8px 24px 8px 16px;
  text-align: left;
  cursor: pointer;
  font-family: Mada;
  font-size: 16px;
  color: ${colors.g04};

  &:last-child {
    margin-bottom: unset;
  }

  &.active {
    font-weight: bold;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: ${colors.b03};
    color: ${colors.b01};
  }
`;

const DurationFilter = ({ metricsDuration, changeMetricsDuration, getAll }) => {
  const durationList = [{ title: '7 days', value: 7 }, { title: '30 days', value: 30 }];
  const [isMenuOpen, setMenuOpen] = useState(false);

  const openDropdown = () => {
    setMenuOpen(true);
  };

  const closeDropdown = () => {
    setMenuOpen(false);
  };

  const metricsDurationTitle = () => {
    const index = durationList.findIndex(item => item.value === metricsDuration);
    return index > -1 ? durationList[index].title : '';
  };

  const handleDurationChange = days => {
    changeMetricsDuration(days);
    getAll();
  };

  return (
    <DateFilterWrapper
      onFocus={openDropdown}
      onBlur={closeDropdown}
      onMouseOver={openDropdown}
      onMouseLeave={closeDropdown}
    >
      <DurationSelected>
        Show last {metricsDurationTitle()}
        <ChevronIcon src={Chevron} isMenuOpen={isMenuOpen} />
      </DurationSelected>
      {isMenuOpen && (
        <DurationList>
          {durationList.map(duration => (
            <DurationItem
              key={duration.value}
              className={metricsDuration === duration.value ? 'active' : ''}
              onClick={() => handleDurationChange(duration.value)}
            >
              Last {duration.title}
            </DurationItem>
          ))}
        </DurationList>
      )}
    </DateFilterWrapper>
  );
};

DurationFilter.propTypes = {
  metricsDuration: PropTypes.number.isRequired,
  changeMetricsDuration: PropTypes.func.isRequired,
  getAll: PropTypes.func.isRequired
};

export default compose(
  connect(
    state => ({
      metricsDuration: state.me.metricsDuration
    }),
    {
      changeMetricsDuration: changeMetricsDurationAction,
      getAll: jobGetAllAction
    }
  )
)(DurationFilter);
